import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-enviornment-selection',
  templateUrl: './enviornment-selection.component.html',
  styleUrls: ['./enviornment-selection.component.scss']
})
export class EnviornmentSelectionComponent implements OnInit {

  envData: any;
  selectedEnv: any;
  data: any = [];
  loaderSet = true;
  selectedClient: any;
  selectedBrand: any;
  clients: any = [];
  brands: any = [];
  selectedPreferences: any = {};

  constructor(private userService: UserService,
    @Inject(MAT_DIALOG_DATA) private passedData: any,
    private dialogRef: MatDialogRef<EnviornmentSelectionComponent>,
    private sessionService: SessionService,
    private route: Router,
  ) { }

  ngOnInit(): void {
    // this.getRegions();
    //this.getUserPreferrenceBrand();
    // this.getClientNames();
    this.getUserPreferences();

  }

  getRegions() {
    this.userService.getRegions().subscribe((res: any) => {
      console.log(res);
      this.envData = res;
    })
  }

  getUserPreferences() {
    this.userService.getPreferences().subscribe((res: any) => {
      if (res && res?.length > 0) {
        this.selectedPreferences = res[0];
        if (this.selectedPreferences && this.passedData.changePreference) {
          this.getClientNames();
        }
      } else {
        this.getClientNames();
      }
    })
  }

  getClientNames() {
    this.userService.getClientNames()
      .subscribe({
        next: (res: any) => {
          this.clients = res || [];
          this.selectedClient = this.clients.find((c: any) => c.client_key == this.selectedPreferences?.client_key);
          if (this.selectedPreferences && this.passedData.changePreference) {
            this.getUserPreferrenceBrand()
          }
        }
      })
  }



  getUserPreferrenceBrand() {
    this.userService.getUserPreferrence(this.selectedClient.client_key).subscribe((res: any) => {
      this.brands = res;
      this.selectedBrand = this.brands.find((b: any) => b.brand_key == this.selectedPreferences?.brand_key);
    })
  }

  getClients() {
    this.sessionService.setStoreData('envHeaderVariables', this.selectedEnv);
    let envHeaders = sessionStorage.getItem('envHeaderVariables');
    if (envHeaders) {
      this.userService.getClientNames().subscribe((client: any) => {
        this.clients = client || [];
      });
    }
  }

  getBrands() {
    if (this.selectedClient) {
      this.userService.getBrands(this.selectedClient.client_key).subscribe({
        next: (res: any) => {
          this.brands = res;
          this.selectedBrand = null;

        }
      })

    }
  }

  envSelection() {
    if (!this.loaderSet) return;
    const { region_code, region_key, region_name, secret_name_db } = this.selectedBrand
    this.selectedEnv = { region_code, region_key, region_name, secret_name_db },

      this.sessionService.setStoreData('envHeaderVariables', this.selectedEnv);
    this.sessionService.setEnvSessionVariable(this.selectedBrand);
    setTimeout(() => {
      this.loaderSet = false;
    }, 2000);

    let user_id = JSON.parse(localStorage.getItem('username') || '');

    let payload = {
      client_key: this.selectedClient.client_key,
      brand_key: this.selectedBrand.brand_key,
      user_id: user_id._value
    }
    this.userService.updatePreference(payload).subscribe({
      next: () => {
        let sessionData = {
          client_key: this.selectedClient.client_key,
          brand: this.selectedBrand,
          user_id: user_id._value
        }
        this.dialogRef.close(sessionData);
      },
      error: () => {
        this.loaderSet = true; // keep dialog open
      }
    });
    //sessionStorage.setItem("allClients", JSON.stringify(this.clients));
  }

  close() {
    this.dialogRef.close();    
    if (!this.passedData?.closedOnScreen) {
      this.route.navigate([`aggregation/`]);
    }
  }


  ngOnDestroy() {
  }

}